import React from "react";

const AccordionDownIcon = ({ width = "16", height = "16" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.52729 5.52876C3.78764 5.26841 4.20975 5.26841 4.4701 5.52876L7.9987 9.05735L11.5273 5.52876C11.7876 5.26841 12.2098 5.26841 12.4701 5.52876C12.7305 5.78911 12.7305 6.21122 12.4701 6.47157L8.4701 10.4716C8.20975 10.7319 7.78764 10.7319 7.52729 10.4716L3.52729 6.47157C3.26694 6.21122 3.26694 5.78911 3.52729 5.52876Z"
      fill="#4A4A4A"
    />
  </svg>
);

export default AccordionDownIcon;
